// extracted by mini-css-extract-plugin
module.exports = {"feedback":"FeedbackBanner_feedback__bPZ-D","feedback__info":"FeedbackBanner_feedback__info__1JAT4","feedback__image":"FeedbackBanner_feedback__image__2MoGW"};